"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreateTooltip {
    constructor(container) {
        this.container = container;
    }
    create(tooltip, id = null) {
        var _a, _b, _c, _d, _e, _f;
        let template = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.c-openstreetmap__pin-tooltip');
        let clone = template === null || template === void 0 ? void 0 : template.cloneNode(true);
        if (!((_b = tooltip.image) === null || _b === void 0 ? void 0 : _b.src)) {
            const figure = clone.content.querySelector('figure');
            if (figure) {
                figure.remove();
            }
        }
        let html = clone.innerHTML;
        html = html
            .replace('{TOOLTIP_HEADING}', tooltip.title ? tooltip.title : '')
            .replace('{TOOLTIP_DIRECTIONS_URL}', ((_c = tooltip.directions) === null || _c === void 0 ? void 0 : _c.url) ? tooltip.directions.url : '')
            .replace('{TOOLTIP_DIRECTIONS_LABEL}', ((_d = tooltip.directions) === null || _d === void 0 ? void 0 : _d.label) ? tooltip.directions.label : '')
            .replace('{TOOLTIP_EXCERPT}', tooltip.excerpt ? tooltip.excerpt : '')
            .replace('{TOOLTIP_IMAGE_SRC}', ((_e = tooltip.image) === null || _e === void 0 ? void 0 : _e.src) ? tooltip.image.src : '')
            .replace('{TOOLTIP_IMAGE_ALT}', ((_f = tooltip.image) === null || _f === void 0 ? void 0 : _f.alt) ? tooltip.image.alt : '')
            .replace('{TOOLTIP_ID}', id ? id : '');
        return html;
    }
}
exports.default = CreateTooltip;
